import { render, staticRenderFns } from "./MainsConnection.vue?vue&type=template&id=2bae1bff&scoped=true&"
import script from "./MainsConnection.vue?vue&type=script&lang=ts&"
export * from "./MainsConnection.vue?vue&type=script&lang=ts&"
import style0 from "./MainsConnection.vue?vue&type=style&index=0&id=2bae1bff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae1bff",
  null
  
)

export default component.exports